export default __webpack_public_path__ + "static/media/ramen.64a04c32.webp";